<div *ngIf="!useCustomHeaderTemplate">
    <div fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="start center" class="mb-16">
        <div fxFlex.gt-sm="80" fxFlex>
            <h1 class="font-size-36 p-0 m-0 primary-text-color">{{ headerlangKey | translate }}</h1>
        </div>
        <div fxFlex.gt-sm="20" fxFlex fxLayoutAlign="end center">
            <div *ngIf="enableToCreateUser">
                <button mat-raised-button (click)="createUser()" color="primary" [disabled]="loading">
                    {{ createButtonLangKey | translate }}
                </button>
            </div>
        </div>
    </div>
    <div fxLayout.gt-sm="row" fxLayout="column" class="mb-16">
        <div fxFlex.gt-sm="80" fxFlex>
            <div class="search-area" *ngIf="enableSearchUser">
                <div class="w-100-p custom-search-box" fxFlex="1 0 auto" fxLayout="row">
                    <div class="search-section" fxLayout="row" fxLayoutAlign="center center">
                        <div
                            class="search-icon h-20"
                            [matMenuTriggerFor]="categoryMenu"
                            fxLayout="row"
                            fxLayoutAlign="start center"
                        >
                            <div>
                                <button mat-icon-button>
                                    <mat-icon class="search-icon menu-icon-text-color">{{
                                        seletedSearchBy?.Icon
                                    }}</mat-icon>
                                    <mat-icon class="ml-10">arrow_drop_down</mat-icon>
                                </button>
                            </div>
                        </div>
                        <mat-menu #categoryMenu="matMenu" [overlapTrigger]="false">
                            <button
                                mat-menu-item
                                class="menu-button-text-style"
                                *ngFor="let searchBy of searchByList; let i = index"
                                (click)="setSelectSearchBy(searchBy)"
                            >
                                <mat-icon class="search-icon menu-icon-text-color">{{ searchBy?.Icon }}</mat-icon>
                                {{ searchBy?.Label }}
                            </button>
                        </mat-menu>
                    </div>
                    <div class="search-input-field w-90-p">
                        <input
                            type="text"
                            [(ngModel)]="searchKey"
                            (ngModelChange)="clearSearchKey()"
                            (keyup.enter)="getResultForSearchKey($event)"
                            placeholder="{{ seletedSearchBy?.PlaceHolder | translate }}"
                        />
                    </div>
                    <div class="search-close" *ngIf="searchKey">
                        <button mat-icon-button class="search-clear" (click)="searchFieldCloseIconClick()">
                            <mat-icon class="secondary-text-color-two">close</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div fxFlex.gt-sm="20" fxFlex fxLayoutAlign="end center" *ngIf="enableFilterByRole">
            <mat-form-field class="">
                <mat-label>Display</mat-label>
                <mat-select
                    [(ngModel)]="seletedFilterRole"
                    (selectionChange)="onSelectionChange($event)"
                    placeholder="{{ filterByLangKey | translate }}"
                >
                    <mat-option *ngFor="let role of userRolesFilter" [value]="role">
                        {{ role.Value }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</div>

<ng-container *ngIf="useCustomHeaderTemplate">
    <div *ngTemplateOutlet="headerTemplate"></div>
</ng-container>
